import axios from "axios";
import firebase from "firebase";
import store from './store';
import jwt_decode from "jwt-decode";

axios.interceptors.request.use(function (config) {
    var currentTime = Math.round(new Date() / 1000);
    if (store.getters.getCurrentLoggedInTime != null && currentTime > store.getters.getCurrentLoggedInTime) {
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                firebase.auth().currentUser.getIdToken(true).then(idToken => {
                    var decoded = jwt_decode(idToken)
                    document.cookie = "token=";
                    document.cookie = "token=" + idToken + ";";
                    store.commit("setCurrentLoggedInTime", decoded.exp);
                    store.commit("addToken", idToken);
                    config.headers['Authorization'] = 'Bearer ' + idToken;
                    return config;
                }).catch(err => {  
                    alert("Your session has expired, Please Re Login");
                    console.log("error==", err);
                    store.commit("ClearState", "");
                    document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
                    document.cookie = "staysigned=";
                    document.cookie = "userrole=";
                    document.cookie = "userid=";
                    firebase
                        .auth()
                        .signOut()
                        .then(
                            function () {
                                console.log("Signed Out");
                            },
                            function (error) {
                                console.error("Sign Out Error", error);
                            }
                        );

                    location.href = "/";

                })
            }
        });

    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    //let originalRequest = response.config;
    // if (response.data.status === -10 && !originalRequest._retry) {
    //     originalRequest._retry = true;
    //     firebase.auth().currentUser.getIdToken(true).then(idToken => {
    //         var decoded = jwt_decode(idToken)
    //         document.cookie = "token=";
    //         document.cookie = "token=" + idToken + ";";
    //         store.commit("setCurrentLoggedInTime", decoded.exp);
    //         store.commit("addToken", idToken);
    //         originalRequest.headers['Authorization'] = 'Bearer ' + idToken;
    //         return axios(originalRequest);
    //     }).catch(err => {
    //         console.log("error==", err);
    //         store.commit("ClearState", "");
    //         document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
    //         document.cookie = "staysigned=";
    //         document.cookie = "userrole=";
    //         document.cookie = "userid=";
    //         firebase
    //             .auth()
    //             .signOut()
    //             .then(
    //                 function () {
    //                     console.log("Signed Out");
    //                 },
    //                 function (error) {
    //                     console.error("Sign Out Error", error);
    //                 }
    //             );

    //         location.href = "/";

    //     })
    // }
     if (response.data.status === -11 || response.data.status === -12) {
        store.commit("ClearState", "");
        document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
        document.cookie = "staysigned=";
        document.cookie = "userrole=";
        document.cookie = "userid=";
        firebase
            .auth()
            .signOut()
            .then(
                function () {
                    console.log("Signed Out");
                },
                function (error) {
                    console.error("Sign Out Error", error);
                }
            );

        location.href = "/";
    } else {
        return response
    }
}, function (error) {
    return Promise.reject(error);
});














